import axios from 'axios';
import { useFetch } from '@/utils/apiUtils';

const notificationListApi = {
	/**
	 * 알람리스트 조회
	 * @param {*} param
	 * @returns
	 */
	getNotificationList: async (param) => {
		let result = null;
		await axios
			.post(`${process.env.VUE_APP_API_URL_API}/api/v1/site-menu/getList`, param)
			.then(async (response) => {
				result = response.data;
			})
			.catch((error) => {
				console.log(error);
			});
		return result;
	},
	/**
	 * 확인처리
	 * @param {*} param
	 * @returns
	 */
	setAlarmStatusChange: async (params) => {
		// let result = null;
		// await axios.post(`${process.env.VUE_APP_API_URL_API}/api/v1/monitoring/setAlarmStatusChange`, param).then(async (response) => {
		//     result = response.data;
		// }).catch((error) => {
		//     console.log(error)
		// })
		// return result
		return await useFetch('/api/v1/monitoring/setAlarmStatusChange', params);
	},

	/**
	 * 2024.07.30
	 * 알람내역 화면 selectbox 고정값 - 초기에 받아와서 변하지 않음.
	 * @returns
	 */
	getAlarmFilter: async (params) => {
		return await useFetch('/api/v1/monitoring/getAlarmFilter', params);
	},

	/**
	 * 2024.07.31
	 * 알람내역 총알람수
	 * @returns
	 */
	getAlarmTotalCount: async (params) => {
		return await useFetch('/api/v1/monitoring/getAlarmTotalCount', params);
	},

	/**
	 * 2024.07.30
	 * 알람내역 검색결과
	 * @returns
	 */
	getAlarm: async (params) => {
		return await useFetch('/api/v1/monitoring/getAlarm', params);
	},
};

export default notificationListApi;
